import { render, staticRenderFns } from "./form-create.vue?vue&type=template&id=eec6c5b4&scoped=true&"
import script from "./form-create.vue?vue&type=script&lang=js&"
export * from "./form-create.vue?vue&type=script&lang=js&"
import style0 from "./form-create.vue?vue&type=style&index=0&id=eec6c5b4&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eec6c5b4",
  null
  
)

export default component.exports